<template>
  <div class="user-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="sides-padding">
      <div class="user-page__body">
        <UserPageAsideComponent v-model="activePage" :pages="pages" />
        <button @click="showMenu" class="user-page__nav-btn btn btn--md btn--gray">Навигация</button>
        <component
          ref="page"
          :is="activePage.page"
          v-if="activePage"
          :sharedHash="sharedHash"
          :loading="loading"
          @reload="reload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UserPageAsideComponent from "./components/UserPageAsideComponent.vue";
import ProfilePage from "./pages/profile/index.vue";
import AddressPage from "./pages/address/index.vue";
import OrdersPage from "./pages/orders/index.vue";
import WishlistPage from "./pages/wishlist/index.vue";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import UserMenu from "components/menus/components/UserMenu.vue";
import USER_ADDRESSES_PAGE from "@/graphql/pages/user/UserAddressesPage.graphql";
import USER_ORDERS_PAGE from "@/graphql/pages/user/UserOrdersPage.graphql";
import USER_FAVORITES_PAGE from "@/graphql/pages/user/UserFavoritesPage.graphql";

// Страницы
let pages = [
  {
    link: "profile",
    title: "Регистрационные данные",
    route: { name: "user", params: { link: "profile" } },
    page: ProfilePage,
    // Здесь грузится только история покупок т.к. личные данные грузятся в entry-server.js
    // без этих данных вход на эту страницу невозможен/не имеет смысла
  },
  {
    link: "address",
    title: "Адреса доставки",
    route: { name: "user", params: { link: "address" } },
    page: AddressPage,
    query: USER_ADDRESSES_PAGE,
  },
  {
    link: "orders",
    title: "История покупок",
    route: { name: "user", params: { link: "orders" } },
    page: OrdersPage,
    query: USER_ORDERS_PAGE,
    first: 50,
  },
  {
    link: "wishlist",
    title: "Мой список желаний",
    route: { name: "user", params: { link: "wishlist" } },
    page: WishlistPage,
    query: USER_FAVORITES_PAGE,
  },
];

async function load(apollo, store, route, variables = {}) {
  let activePage = pages.find((item) => item.link === route.params.link) || pages[0];
  variables.first = activePage.first;
  if (activePage.query) {
    apollo.defaultClient
      .query({
        query: activePage.query,
        variables: variables,
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: "Bearer " + store.state.apollo_token,
          },
        },
      })
      .then(({ data }) => {
        if (data.addresses) store.state.auth.addresses = data.addresses;
        if (data.my_orders_paginate) store.state.auth.orders = data.my_orders_paginate.data;
        // store.state.auth.favorites_paginate = data.products_paginate;
        if (data.favorites) store.state.auth.favorites = data.favorites;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  }
}

export default {
  name: "UserPage",
  // async asyncData({ apollo, store, route }) {
  //   await load(apollo, store, route);
  // },
  props: {
    link: {
      type: String,
      default: null,
    },
    sharedHash: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pages: pages,
      loading: false,
    };
  },
  mounted() {
    try {
      this.loading = true;
      this.load(this.$apolloProvider, this.$store, this.$route);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    orders() {
      return this.$store.state.auth.orders;
    },
    links() {
      return [{ title: "Персональный раздел", route: { name: "user" } }, { title: this.activePage.title }];
    },
    activePage() {
      // Используем либо props link, либо параметр из маршрута
      const linkToUse = this.link || this.$route.params.link;
      return this.pages.find((page) => page.link === linkToUse) || this.pages[0];
    },
  },
  methods: {
    showMenu() {
      this.$store.state._menus.push({
        component: UserMenu,
        options: {},
      });
    },
    async reload() {
      await this.load(...arguments);
      this.$refs.page.stopLoading();
    },
    load,
  },
  components: { BreadcrumbsComponent, UserPageAsideComponent },
  metaInfo() {
    return {
      title: this.activePage.title,
    };
  },
};
</script>

<style lang="stylus">
.user-page {
  padding 32px 0 96px
  display grid
  align-items start
  grid-gap 30px
  +below(680px) {
    padding 30px 0
  }

  &__body {
    display grid
    align-items start
    grid-template-columns 3fr 9fr
    grid-gap 24px
    max-width var(--main_width)
    width 100%
    margin 0 auto
    +below(1024px) {
      grid-template-columns 4fr 8fr
    }
    +below(860px) {
      grid-template-columns 1fr
    }
    +below(540px) {
      grid-gap 15px
    }
  }

  &__nav-btn {
		display: none
		position: absolute
    +below(860px) {
      display flex
			position: static
    }
  }

  &__content {
    display grid
    grid-gap 30px
  }

  &__footer {
    display: flex;
    justify-content flex-end
    align-items center

    .btn {
      +below(420px) {
        width 100%
      }
    }
  }
}
</style>
